package main.kotlin.models

import main.kotlin.comms.CredentialProvider
import org.w3c.dom.set
import kotlin.browser.window

open class TestScreen
{

}